import React from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { confirmDialog } from 'primereact/confirmdialog'
import { getMessageFromFormErrors } from 'helper/error'
import { classNames } from 'primereact/utils'

export default function EnderecoProdutoAutoComplete({
    selecionados,
    setSelecionados,
    filtrados,
    carregarEnderecos,
    enderecoFormatado,
    form,
    controller,
    beforeInsert,
    beforeDelete,
    placeholder,
    label,
    inputId
}) {
    const handleChange = (e) => {
        const novoValor = e.value

        if (novoValor.length < selecionados.length) {
            const removido = selecionados.find((s) => !novoValor.includes(s))

            confirmDialog({
                message: `Remover o endereço ${enderecoFormatado(removido)}?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (!beforeDelete || beforeDelete(removido)) {
                        setSelecionados(novoValor)
                    }
                },
            })
        } else {
            const inserido = novoValor.find((item) => !selecionados.includes(item))

            if (!beforeInsert || beforeInsert(inserido)) {
                setSelecionados(novoValor)
            }
        }
    }

    const getFormErrorMessage = (name) => {

        if (form && name) {
            const message = getMessageFromFormErrors(form.formState.errors, name)
            return message ? <small className="p-error">{message}</small> : <small className="p-error"></small>
        }

        return ''
    }

    return (
        <div className='flex flex-column'>
            <label htmlFor={inputId || 'searchEndereco'} className='mb-1 text-sm'>{label || 'Endereços'}</label>
            <AutoComplete
                multiple
                inputId={inputId || 'searchEndereco'}
                className={'p-inputtext-sm ' + (controller?.fieldState?.isDirty ? '' : '') + classNames({ 'p-invalid': controller?.fieldState?.error })}
                size='small'
                field='codigo_endp'
                value={selecionados}
                suggestions={filtrados}
                completeMethod={carregarEnderecos}
                onChange={handleChange}
                itemTemplate={(item) => <span>{enderecoFormatado(item)}</span>}
                selectedItemTemplate={(item) => {
                    return <span className={`${item?.principal ? 'font-bold' : ''}`} >{enderecoFormatado(item)}</span>
                }}
                forceSelection={true}
                autoComplete='off'
                placeholder={placeholder || ''}
            />
            {getFormErrorMessage(controller?.field?.name)}
        </div>
    )
}
